import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../../hoc/Aux';
import axios from '../../axios-ns';
import * as messages from '../../messages';

class AutoSignIn extends Component {
    state = {
        error: null,
        loading: false,
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: messages.YOUR_EMAIL
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: messages.PASSWORD
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        }
    };

    checkValidity(value, rules) {
        let isValid = true;

        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName.validation]),
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.authenticate(this.state.controls.email.value, this.state.controls.password.value);
    }

    authenticate = (email, password) => {
        this.setState({ ...this.state, loading: true });
        const authData = {
            email: email,
            password: password
        }

        let url = 'authenticate';

        axios.post(url, authData)
            .then(response => {
                const expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 10);
                localStorage.setItem('token', response.data);
                localStorage.setItem('expirationDate', expirationDate);

                this.setState({ ...this.state, isAuthenticated: true, error: null, loading: false });
                setInterval(() => {
                    if (new Date() >= new Date(localStorage.getItem('expirationDate'))) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('expirationDate');
                        this.props.history.replace('/signin');
                    }
                }, 1000 * 60 * 30);
            })
            .catch(err => {
                this.setState({ ...this.state, error: messages.INCORRECT_EMAIL_OR_PASSWORD, loading: false });
            });
    }

    render() {
        // alert(new URLSearchParams(this.props.location.search).get("dupa"));

        const search = new URLSearchParams(this.props.location.search);

        const authData = {
            email: search.get('xwt'),
            password: search.get('ps')
        }

        //vocaldemy/front/auto-signin?xwt=irek.1992.r@gmail.com&ps=gfr23da21343mndfgrewdswns

        let url = 'authenticate';

        axios.post(url, authData)
            .then(response => {
                const expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 10);
                localStorage.setItem('token', response.data);
                localStorage.setItem('expirationDate', expirationDate);

                this.setState({ ...this.state, isAuthenticated: true, error: null, loading: false });
                setInterval(() => {
                    if (new Date() >= new Date(localStorage.getItem('expirationDate'))) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('expirationDate');
                        this.props.history.replace('/sign-in');
                    }
                }, 1000 * 60 * 30);
                this.props.history.push('/buy-product/PW');
            })
            .catch(err => {
                this.setState({ ...this.state, error: messages.INCORRECT_EMAIL_OR_PASSWORD, loading: false });
            });

        return <Aux><div></div></Aux>

    }
}

export default AutoSignIn; 